<p-toast position="top-right" />

<section class="modules p-5 md:p-7 lg:p-8">
  <div class="mx-auto max-w-[1500px]">
    <div class="grid grid-cols-1 gap-8 lg:grid-cols-[16rem_minmax(0,1fr)]">
      <aside>
        <p-menu [model]="profileMenu" styleClass="w-full" aria-label="Menú de Mi Perfil"></p-menu>
      </aside>

      <main>
        <header class="mb-6">
          <h2 class="m-0 text-xl font-semibold">{{ activeMenuItem.title }}</h2>
          <p class="m-0 mt-1">{{ activeMenuItem.description }}</p>
        </header>

        <div *ngIf="loading" class="flex flex-col gap-6">
          <p-skeleton height="9rem"></p-skeleton>
          <p-skeleton height="9rem"></p-skeleton>
          <p-skeleton height="9rem"></p-skeleton>
        </div>

        <div *ngIf="!loading" class="flex flex-col gap-6">
          <app-profile-password-factor
            [passwordForm]="passwordForm"
            [showPasswordDialog]="showPasswordDialog"
            [changingPassword]="changingPassword"
            (openPasswordDialog)="openPasswordDialog()"
            (closePasswordDialog)="closePasswordDialog()"
            (submitPasswordChange)="changePassword()"
          ></app-profile-password-factor>

          <app-profile-two-factor-section
            [totpEnabled]="totpEnabled"
            [loadingStatus]="loadingTwoFactor"
            [startingEnrollment]="startingTotpEnrollment"
            [confirmingEnrollment]="confirmingTotpEnrollment"
            [disablingTotp]="disablingTotp"
            [showSetupDialog]="showTotpSetupDialog"
            [setupStep]="totpSetupStep"
            [enrollment]="totpEnrollment"
            [totpPasswordForm]="totpPasswordForm"
            [totpVerifyForm]="totpVerifyForm"
            [showDisableDialog]="showTotpDisableDialog"
            [totpDisableForm]="totpDisableForm"
            (openSetupDialog)="openTotpSetupDialog()"
            (closeSetupDialog)="closeTotpSetupDialog()"
            (submitEnrollmentPassword)="startTotpEnrollment()"
            (submitEnrollmentCode)="confirmTotpEnrollment()"
            (openDisableDialog)="openTotpDisableDialog()"
            (closeDisableDialog)="closeTotpDisableDialog()"
            (submitDisableTotp)="disableTotp()"
            (copySecret)="copyTotpSecret($event)"
            (setupStepChange)="setTotpSetupStep($event)"
          ></app-profile-two-factor-section>

          <app-profile-passkeys-factor
            [passkeys]="passkeys"
            [supportsPasskeys]="supportsPasskeys"
            [registeringPasskey]="registeringPasskey"
            [deletingCredentialId]="deletingCredentialId"
            [updatingPasskeyCredentialId]="updatingPasskeyCredentialId"
            [showPasskeyNameDialog]="showPasskeyNameDialog"
            [passkeyNameForm]="passkeyNameForm"
            [showDeletePasskeyDialog]="showDeletePasskeyDialog"
            [deletePasskeyForm]="deletePasskeyForm"
            [deletingPasskeyLabel]="deletingPasskey?.label || ''"
            (registerPasskey)="registerPasskey()"
            (deletePasskey)="deletePasskey($event)"
            (openPasskeyNameDialog)="openPasskeyNameDialog($event)"
            (closePasskeyNameDialog)="closePasskeyNameDialog()"
            (savePasskeyName)="savePasskeyName()"
            (closeDeletePasskeyDialog)="closeDeletePasskeyDialog()"
            (confirmDeletePasskey)="confirmDeletePasskey()"
          ></app-profile-passkeys-factor>
        </div>
      </main>
    </div>
  </div>
</section>
